module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "c-card--orders__single__order-number"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_number', {
    order_number: _vm.order.short_order_id
  })))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--orders__single__item"
  }, [_c('router-link', {
    staticClass: "t-link",
    attrs: {
      "to": {
        name: 'Single Reward',
        params: {
          id: _vm.order.reward_id
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.order.reward_name) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__single__datagroup"
  }, [_c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.date')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.points')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v("\n        " + _vm._s(_vm.order.order_total) + "\n      ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.quantity')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.item_quantity))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.updated')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.updated))])])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__single__datagroup"
  }, [_c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_status')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.statusColor(_vm.order.order_status)
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), (!_vm.order.email_status) ? _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.shipping_status')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.statusColor(_vm.order.shipping_status)
  }, [_vm._v(_vm._s(_vm.order.shipping_status))])])]) : _vm._e(), _vm._v(" "), (!_vm.order.email_status) ? _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v("\n        " + _vm._s(_vm.order.carrier_tracking) + "\n        "), (!_vm.order.carrier_tracking) ? _c('span', {
    staticClass: "c-card--orders__single__data__value__empty"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking_unavailable')))]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c74a80a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/RewardOpsOrderCard.vue
// module id = 526
// module chunks = 1